/*!
 * Helper methods shared amongst the other js files.
 * Copyright (c) 2016 Frameworks AS
 */

var UArctic = window.UArctic || {}; //Creates a namespace to keep our method away from colliding with other code
UArctic.Helpers = UArctic.Helpers || {};

UArctic.Helpers.Url = {
	/*
	 * Gets a named QueryString parameter. If no url is provided then it will use current location.href.
	 */
	getParameterByName: function (name, url) {
		if (!url) url = window.location.href;
		url = url.toLowerCase(); // This is just to avoid case sensitiveness
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return ''; 
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
};